export const resume = {
    basics: {
        name: 'Chien-Ting Weng',
        label: 'Software Engineer',
        email: 'wchient@gmail.com',
        phone: '1 (412) 641-9532',
        skills: {
            'Programming': [
                'Java',
                'Golang',
                'Python',
                'JavaScript',
                'HTML/CSS',
                'SQL',
                'Pig',
                'ObjectiveC',
                'C/C++',
                'Git',
                'Continuous Integration',
                'Continuous Delivery'
            ],
            'Software Developement Experience': [
                'GIT',
                'Terraform',
                'Kubernetes',
                'Docker',
                'Dropwizard',
                'NodeJS',
                'ReactJS',
                'SQL',
                'Hadoop',
                'Spark',
                'Pig',
                'Hive',
                'Machine Learning',
                'Unstructured Data Analytics' 
            ],
            'Project Management': [
                'Agile',
                'Project Management (PMP Certificate)'
            ]
        }
    },
    social: {
        facebook: 'https://www.facebook.com/cityw',
        github: 'https://www.github.com/wchient',
        linkedin: 'https://www.linkedin.com/in/ctweng/',
        mail: 'mailto://wchient@gmail.com',
        resume: 'https://drive.google.com/file/d/1mFBriupLbU8vOrIfCDSq3yYvuyCE0X6i/view'
    },
    work: [
        {
            company: 'Oracle Cloud Infrastructure',
            position: 'Senior Software Engineer',
            period: 'Dec 2019 - Present',
            summary: [
                'Microservice Developement',
                'SSH Service Development',
                'Automatic Infrastructure Setup'
            ],
            highlights: ['Java', 'Golang', 'Dropwizard', 'Terraform', 'Kubernetes', 'Docker']
        },
        {
            company: 'Yahoo/Oath',
            position: 'Data Engineer and Web Developer',
            website: 'http://www.yahoo.com',
            period: 'Oct 2016 - Jun 2018',
            summary: [
                'Ad-hoc Reporting',
                'Data Platform'
            ],
            highlights: ['Pig', 'Hive', 'Hadoop', 'Oozie', 'Python', 'SQL', 'Druid']
        },
        {
            company: 'Yahoo',
            position: 'Web Developer',
            website: 'http://www.yahoo.com',
            period: 'Oct 2013 - Oct 2016',
            summary: [
                'Web Search Optimization and Search platform migration.',
                'Yahoo Shopping Search Service in Canada'
            ],
            highlights: ['Java', 'Tomcat', 'Hibernate', 'PHP', 'JavaScript', 'JUnit', 'Seleniun', 'Functional Test', 'Git']
        },
        {
            company: 'Self Employed (Collaborator with Memes Creative Partnership, Taipei Taiwan)',
            position: 'iOS Application Engineer',
            website: '',
            period: 'Jan 2010 - Jun 2010',
            summary: [
                'Design and develop an interactive hair-cutting game on iPhone.'
            ],
            highlights: ['OpenGL', 'Objective C', 'C++']
        }
    ],
    education: [
        {
            school: 'Carnegie Mellon University',
            area: 'Information System Management - Business Intelligence and Data Analytics',
            studyType: 'M.S. in Business Intelligence and Data Analytics',
            period: 'Aug 2018 - Aug 2019 (Exp)',
            gpa: '3.92 (presumed)',
            logo: 'https://www.cmu.edu/marcom/brand-standards/images/logos-colors-type/full-color-seal-min.png',
            courses: [
                'Database Management',
                'Data Focused Python',
                'Machine Learning',
                'Distributed System',
                'Unstructured Data Analytics'
            ],
        },
        {
            school: 'National Taiwan University',
            area: 'Computer Science - Human Computer Interaction',
            studyType: 'M.S in Computer Science',
            period: 'Aug 2011 - Jul 2013',
            gpa: '3.93',
            courses: [
                'Computational Complexity',
                'Digital Image Processing',
                'Digital Visual Effects',
                'Computational Photography',
                'Digital Speech Processing'
            ],
        },
        {
            school: 'National Taiwan University',
            area: 'Computer Science',
            studyType: 'B.S in Computer Science',
            period: 'Sep 2006 - Jul 2010',
            gpa: '3.84',
            courses: [
                'Data Structure and Algorithm',
                'Linear Algebra',
                'Discrete Mathematics',
                'Computer Networking',
                'Web Mining',
                'Design Pattern',
                'Database'
            ],
        },
    ],
    publications: [
        {
            title: 'NailDisplay: Bringing an Always: Available Visual Display to Fingertips,',
            publisher: 'ACM CHI 2013',
            award: 'Best Paper Award',
            videoId: 'ZyWDBDGGh4M'
        },
        {
            title: 'GaussSense: Attachable Stylus Sensing Using Magnetic Sensor Grid,',
            publisher: 'ACM UIST 2012',
            award: '',
            videoId: 'ifwDZwgmcLI'
        }
    ]
};


// WEBPACK FOOTER //
// ./src/Infos/resume.js